import React from "react";
import styles from "./styles.module.css";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { InputProps } from "../types";

interface SelectInputProps extends InputProps {
  options: string[];
}

export const SelectInput = ({
  error,
  placeholder,
  disabled,
  type,
  autoFocus,
  value = "",
  onChange,
  options
}: SelectInputProps) => (
  <FormControl
    className={styles.component}
    error={error !== undefined}
    {...{ disabled }}
  >
    <InputLabel id={`select-label=${placeholder}`}>{placeholder}</InputLabel>
    <Select
      labelId={`select-label=${placeholder}`}
      {...{
        type,
        autoFocus,
        value,
        onChange: evt => onChange && onChange(evt.target.value as string)
      }}
    >
      {options.map((value, index) => (
        <MenuItem {...{ value }} key={index}>
          {value}
        </MenuItem>
      ))}
    </Select>
    {error && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);
